// extracted by mini-css-extract-plugin
module.exports = {"expandableDropdownText":"_2CfT0IhY"};